import Vue from "vue";
import VueMeta from "vue-meta";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

// import Books from "../components/Books";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // refreshOnceOnNavigation: true
});

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/About",
    name: "About",
    component: import(/* webpackChunkName: "about" */ "../views/About.vue")
  },

  // {
  //   path: "/Vakansija/:vakans",
  //   name: "Vakansija",
  //   component: Vacansija
  // },
  {
    path: "/Vakansija/:vakans",
    name: "Vakansija",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Vakansija.vue")
  },
  {
    path: "/Think",
    name: "Think",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Think.vue")
  },
  {
    path: "/Signup",
    name: "Signup",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Signup.vue")
  },
  {
    path: "/Books",
    name: "Books",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Books" */ "../views/Books.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
